import { ScoreColorVariant } from '@vizit/constants';
import { cva } from '@vizit/theme';

const stickerClasses = cva({
  base: 'relative flex flex-col items-center justify-center h-64 w-64',
  variants: {
    colorVariant: {
      [ScoreColorVariant.NotApplicable]: 'bg-gray-utility-300',
      [ScoreColorVariant.VeryLow]: 'bg-error-200',
      [ScoreColorVariant.Low]: 'bg-error-200',
      [ScoreColorVariant.Moderate]: 'bg-warning-200',
      [ScoreColorVariant.High]: 'bg-green-yellow-200',
      [ScoreColorVariant.VeryHigh]: 'bg-success-200',
    },
  },
});

const scoreTextClasses = cva({
  base: 'text-center',
  variants: {
    colorVariant: {
      [ScoreColorVariant.NotApplicable]: 'text-secondary',
      [ScoreColorVariant.VeryLow]: 'text-error-900',
      [ScoreColorVariant.Low]: 'text-error-900',
      [ScoreColorVariant.Moderate]: 'text-warning-900',
      [ScoreColorVariant.High]: 'text-green-yellow-900',
      [ScoreColorVariant.VeryHigh]: 'text-success-900',
    },
  },
});

export { scoreTextClasses, stickerClasses };
